// Disabling the rule to remove keyboard navigation focus ring that ds2 Link element had
/* eslint-disable react/forbid-elements */
import { Avatar } from '@change/ds-core-ui';

import { useTopImpactStoryAvatar } from './hooks/useTopImpactStoryAvatar';

export const TopImpactStoryAvatar: React.FC<{
	url: string;
	trackStoryClick: (url: string) => void;
	ariaLabel: string;
	linkDataTestId: string;
	image: string;
	altText: string;
	imageDataTestId: string;
	isMobile?: boolean;
	isCenteredOnMobile?: boolean;
	onStoryFocus?: () => void;
	tabIndex?: number;
	ariaHidden?: boolean;
}> = ({
	url,
	trackStoryClick,
	ariaLabel,
	linkDataTestId,
	image,
	altText,
	imageDataTestId,
	isMobile = false,
	isCenteredOnMobile = false,
	onStoryFocus,
	tabIndex = 0,
	ariaHidden = false,
}) => {
	const {
		data: { blurClasses, avatarClasses },
	} = useTopImpactStoryAvatar(isMobile, isCenteredOnMobile);

	return (
		<>
			<div className={blurClasses}>
				<div className="h-full w-full rounded-full bg-surface-accent-secondary-pressed blur-lg filter" />
			</div>

			<a
				href={url}
				className="z-10 block h-full w-full focus-visible:outline-transparent"
				onClick={() => trackStoryClick(url)}
				aria-label={ariaLabel}
				data-testid={linkDataTestId}
				data-qa="top-impact-story-link"
				onFocus={onStoryFocus}
				tabIndex={tabIndex}
				aria-hidden={ariaHidden}
			>
				<div className="relative h-full w-full overflow-visible">
					<div className="h-full w-full overflow-hidden rounded-full">
						<Avatar src={image} alt={altText} className={avatarClasses} data-testid={imageDataTestId} aria-hidden />
					</div>
				</div>
			</a>
		</>
	);
};
